import api from './api';

const departmentReportsService = {
  // Get department expense reports
  getDepartmentReports: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      if (filters.department) params.append('department', filters.department);

      const queryString = params.toString();
      const url = `/department-reports/reports${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error getting department reports:', error);
      throw error;
    }
  },

  // Get department filter options
  getDepartmentFilterOptions: async () => {
    try {
      const response = await api.get('/department-reports/filters');
      return response.data;
    } catch (error) {
      console.error('Error getting department filter options:', error);
      throw error;
    }
  }
};

export default departmentReportsService;

